export const CompanyConfig = {
  name: 'Trailer Solutions FL',
  shortName: 'TSF',
  logoUrl: '/assets/images/tsf-logo-white.png',
  phone: '800-224-8180',
  website: 'https://www.trailersolutionsfl.com',
  privacyUrl: 'https://www.trailersolutionsfl.com/privacy',
  termsUrl: 'https://www.trailersolutionsfl.com/terms-of-use',
  contactUrl: 'https://www.trailersolutionsfl.com/contact',
  dealerFormUrl: 'https://www.trailersolutionsfl.com/form-submitted',
  formSubmittedUrl: 'https://www.trailersolutionsfl.com/form-submitted',
  paymentUrl: 'https://pay.trailersolutionsfl.com',
  dealerDocumentUrl: 'https://get-started.trailersolutionsfl.com/upload-dealer-documents',
  leadFormBaseUrl: 'https://get-started.trailersolutionsfl.com',
  adminEmail: 'credit@trailersolutionsfl.com',
  address: {
    addressLine1: '3306 SW 26th Av #301',
    addressLine2: '',
    city: 'Ocala',
    state: 'FL',
    zipCode: '34471',
  },
  referralSources: [
    'Google',
    'Friend/Family',
    'Dealership',
    'Facebook',
    'Instagram',
    'Returning Customer',
    'Other', //
  ],
};
